module.exports = __webpack_public_path__ + "img/quickshape-cn.38b8ce6.jpg";